import { Component } from '@angular/core';
import { NavController, AlertController } from 'ionic-angular'
import { HomePage } from "../home/home";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { UserService } from "../../providers/session-service/user-service";
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
})
export class LoginPage {

    showSpinner: boolean;
    private credentials: FormGroup;

    constructor(public navCtrl: NavController, private userService: UserService, private formBuilder: FormBuilder,
        private af: AngularFireAuth, private alertCtrl: AlertController, private db: AngularFirestore) {
        this.showSpinner = false;
        this.credentials = this.formBuilder.group({
            email: ['', Validators.email],
            password: ['', Validators.required],
        });
    }

    login() {
        this.showSpinner = true;

        let details = {
            'email': this.credentials.value.email,
            'password': this.credentials.value.password
        };

        this.af.auth.signInWithEmailAndPassword(details.email, details.password).then(userAuthData => {
            this.db.doc("users/" + userAuthData.uid).valueChanges().subscribe(user => {
                this.userService.startSession(user);
                this.navCtrl.setRoot(HomePage);
                this.showSpinner = false;
            });
        }).catch((error) => {
            console.log(error);
            this.showSpinner = false;
            this.userService.createToast('Δεν ήταν δυνατή η σύνδεση στην εφαρμογή. Ελέγξτε τα στοιχεία σας.');
        });

    }

    resetPassword() {
        let emailSent = false;

        let alert = this.alertCtrl.create({
            title: 'Αλλαγή κωδικού',
            message: 'Παρακαλώ δώστε το e-mail σας. Θα σας στείλουμε ένα email με οδηγίες για αλλαγή του κωδικού σας.',
            inputs: [
                {
                    name: 'email',
                    placeholder: 'E-mail',
                    type: 'email'
                }
            ],
            buttons: [
                {
                    text: 'Ακυρο',
                    role: 'cancel'
                },
                {
                    text: 'Αποστολη',
                    handler: data => {
                         this.af.auth.sendPasswordResetEmail(data.email).then(() => {
                             emailSent = true;
                             this.userService.createToast('Για να αλλάξετε τον κωδικό σας ακολουθήστε τις οδηγίες στο e-mail που σας εστάλη.');
                         }, () => {
                             this.userService.createToast('Δεν ήταν δυνατή η αποστολή του κωδικού. Παρακαλώ ελέγξτε το e-mail σας.');
                         });
                    }
                }
            ]
        });
        alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts